import { fun_PostAction } from "@/api/index";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 默认关闭
      dialogVisible: false,
      // 列表loading状态
      loading: false,
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 查询表单字段
      form: {
        prjName: null, // 项目名称
        tenderReference: null, // 招标编号
        tenderCorpName: null, // 招标人
        tenderAgentOrganName: null, // 招标代理机构
        regulators: null, // 行政监督部门
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "项目名称：",
          value: "prjName",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "招标编号：",
          value: "tenderReference",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "招标公告编号：",
          value: "announcementId",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "招标登记编号：",
          value: "registrationId",
          placeholder: "请输入",
          clearable: true
        },
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "项目名称",
          prop: "prjName",
          width: "250",
          isShow: true,
          fixed: true,
        },
        {
          label: "标段",
          prop: "section",
          width: "80",
          fixed: true,
        },
        {
          label: "招标编号",
          prop: "tenderReference",
          width: "180",
        },
        {
          label: "招标公告编号",
          prop: "announcementId",
          width: "180",
        },
        {
          label: "招标登记编号",
          prop: "registrationId",
          width: "180",
        },
        {
          label: "招标人",
          prop: "tenderCorpName",
          width: "200",
        },
        {
          label: "招标联系人",
          prop: "tenderLinkMan",
          width: "200",
        },
        {
          label: "招标代理机构",
          prop: "tenderAgentOrganName",
          width: "200",
        },
        {
          label: "招标代理机构联系人",
          prop: "agencyLinkMan",
          width: "200",
        },
        {
          label: "行政监督部门",
          prop: "regulatorsName",
          width: "280",
        },
        {
          label: "开标时间",
          prop: "openingTime",
          width: "200",
        },
        {
          label: "投标有效期（日历天）",
          prop: "oldTenderValidity",
          width: "220",
        },
        {
          label: "截止日期",
          prop: "endDate",
          width: "180",
        },
      ],
      // 表格数据
      tableData: [],
    };
  },
  // 注册组件
  components: {
  },
  // 模板编译完成
  mounted() {  },
  // 自定义方法
  methods: {
    // 打开弹框时调用
    async fun_GetOpen() {
      // 查询一览数据
      this.fun_GetList();
    },
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    fun_GetList() {
      // 打开loading
      this.loading = true;
      // 请求，获取结果集
      fun_PostAction("/tenderValidityChange/projectList", {
        ...this.form,
        ...this.reqPageData
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      });
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[i] = e;
    },
    /**
     * 查看详情
     * @params e 点击的行数据
     * @author 付翔
     */
    fun_DetailSelect(e) {
      // 回调函数
      this.$nextTick(() => {
        // 赋值父页面数据
        this.$parent.fun_SetProjectList(e.val);
        // 关闭页面弹框
        this.dialogVisible = false;
      });
    },
  }
};
